export default __webpack_public_path__ + "media/images/landing-43-550x420-3db295b2aff5d0d8c8fe3591c9998e4d.jpg";